import ui from '@sh/helpers/ui';
import { apiStore } from '@sh/services/api';

const placeholder = {
  $: { placeholder: '$', placeholderHtml: '<i class="fa fa-dollar"></i>', placeholderPosition: 'before' },
  '%': { placeholder: '%', placeholderHtml: '<i class="fa fa-percent"></i>', placeholderPosition: 'after' },
};

const fieldsGroup = [
  { value: 'tr', label: 'Trackers Fields' },
  { value: 'ts', label: 'Traffic Sources Fields' },
  // {value: 'ga', label: 'Google Analytics Fields'},
  { value: 'cc', label: 'Custom Conversions Fields' },
  { value: 'other', label: 'Other' },
];

const fieldsMap = {
  ts_impressions: { group: 'ts', value: { behind: 'ARE' }, text: 'Traffic Source Impressions', class: 'badge-yellow-haze' },
  ts_clicks: { group: 'ts', value: { behind: 'ARE' }, text: 'Traffic Source Clicks', class: 'badge-warning' },
  tr_clicks: { group: 'tr', value: { behind: 'ARE' }, text: 'Tracker Clicks', class: 'badge-success' },
  ts_spent: { group: 'ts', value: { behind: 'IS', step: 0.0001, ...placeholder.$ }, text: 'Traffic Source Spent', class: 'badge-secondary' },
  ts_conversions: { group: 'ts', value: { behind: 'ARE' }, text: 'Traffic Source Conversions', class: 'badge-purple-plum' },
  tr_conversions: { group: 'tr', value: { behind: 'ARE' }, text: 'Tracker Conversions', class: 'badge-primary' },
  ts_revenue: { group: 'ts', value: { behind: 'IS', ...placeholder.$, step: 0.01 }, text: 'Traffic Source Revenue', class: 'badge-yellow-casablanca' },
  tr_revenue: { group: 'tr', value: { behind: 'IS', ...placeholder.$, step: 0.01 }, text: 'Tracker Revenue', class: 'badge-dark' },
  lp_clicks: { group: 'tr', value: { behind: 'ARE' }, text: 'Landing Page Clicks', class: 'badge-danger' },
  lp_ctr: { group: 'tr', value: { behind: 'IS', step: 0.01, ...placeholder['%'] }, text: 'Landing Page CTR', class: 'badge-blue-chambray' },
  ts_epc: { group: 'ts', value: { behind: 'IS', ...placeholder.$, step: 0.0001 }, text: 'Traffic Source Earn Per Click', class: 'badge-yellow-gold' },
  epi: { group: 'ts', value: { behind: 'IS', ...placeholder.$, step: 0.0001 }, text: 'Earn Per Impression', class: 'badge-yellow-gold' },
  tr_epc: { group: 'tr', value: { behind: 'IS', ...placeholder.$, step: 0.0001 }, text: 'Tracker Earn Per Click', class: 'badge-yellow-gold' },
  ts_ctr: { group: 'ts', value: { behind: 'IS', ...placeholder['%'], step: 0.01 }, text: 'Traffic Source CTR', class: 'badge-blue-chambray' },
  tr_ctr: { group: 'tr', value: { behind: 'IS', ...placeholder['%'], step: 0.01 }, text: 'Tracker CTR', class: 'badge-blue-chambray' },
  ts_cr: { group: 'ts', value: { behind: 'IS', ...placeholder['%'], step: 0.01 }, text: 'Traffic Source Conversion Rate', class: 'badge-yellow-gold' },
  tr_cr: { group: 'tr', value: { behind: 'IS', ...placeholder['%'], step: 0.01 }, text: 'Tracker Conversion Rate', class: 'badge-yellow-gold' },
  ts_profit: { group: 'ts', value: { behind: 'IS', ...placeholder.$, step: 0.01 }, text: 'Traffic Source Profit', class: 'badge-blue-chambray' },
  tr_profit: { group: 'tr', value: { behind: 'IS', ...placeholder.$, step: 0.01 }, text: 'Tracker Profit', class: 'badge-blue-chambray' },
  ts_roi: { group: 'ts', value: { behind: 'IS', ...placeholder['%'], step: 0.01 }, text: 'Traffic Source ROI', class: 'badge-green-sharp' },
  tr_roi: { group: 'tr', value: { behind: 'IS', ...placeholder['%'], step: 0.01 }, text: 'Tracker ROI', class: 'badge-green-sharp' },
  ts_cpa: { group: 'ts', value: { behind: 'IS', ...placeholder.$, step: 0.001 }, text: 'Traffic Source Cost Per Action', class: 'badge-green-soft' },
  tr_cpa: { group: 'tr', value: { behind: 'IS', ...placeholder.$, step: 0.001 }, text: 'Tracker Cost Per Action', class: 'badge-green-soft' },
  ts_cpc: { group: 'ts', value: { behind: 'IS', ...placeholder.$, step: 0.001 }, text: 'Traffic Source Cost Per Clicks', class: 'badge-light' },
  tr_cpc: { group: 'tr', value: { behind: 'IS', ...placeholder.$, step: 0.001 }, text: 'Tracker Cost Per Clicks', class: 'badge-light' },
  ts_cpi: { group: 'ts', value: { behind: 'IS', ...placeholder.$, step: 0.001 }, text: 'Traffic Source Cost Per Impression', class: 'badge-dark' },
  totalBudget: { group: 'ts', value: { behind: 'IS', ...placeholder.$, step: '0.01' }, text: 'Total Budget', class: 'badge-secondary' },
  dailyBudget: { group: 'ts', value: { behind: 'IS', ...placeholder.$, step: '0.01' }, text: 'Daily Budget', class: 'badge-secondary' },
  bid: { group: 'ts', value: { behind: 'IS', ...placeholder.$, step: '0.01' }, text: 'Bid', class: 'badge-secondary' },
  payout: { group: 'ts', value: { behind: 'IS', ...placeholder.$, step: '0.01' }, text: 'Payout', class: 'badge-secondary' },
  hour_of_day: { group: 'other', value: { behind: 'IS IN', type: 'hour_of_day' }, text: 'Hour of Day', disabled: false },
  today_ts_clicks: { group: 'other', value: { type: 'daily_cap', behind: 'IS' }, text: 'Daily Cap ' },
};
// Set Key
Object.entries(fieldsMap).forEach(([key, item]) => { item.value.key = key; });

const fields = [
  fieldsMap.ts_impressions,
  fieldsMap.ts_clicks,
  fieldsMap.tr_clicks,
  fieldsMap.ts_spent,
  fieldsMap.ts_conversions,
  fieldsMap.tr_conversions,
  fieldsMap.ts_revenue,
  fieldsMap.tr_revenue,
  fieldsMap.totalBudget,
  fieldsMap.dailyBudget,
  fieldsMap.bid,
  fieldsMap.lp_clicks,
  fieldsMap.lp_ctr,
  fieldsMap.ts_epc,
  fieldsMap.epi,
  fieldsMap.tr_epc,
  fieldsMap.ts_ctr,
  fieldsMap.tr_ctr,
  fieldsMap.ts_cr,
  fieldsMap.tr_cr,
  fieldsMap.ts_profit,
  fieldsMap.tr_profit,
  fieldsMap.ts_roi,
  fieldsMap.tr_roi,
  fieldsMap.ts_cpa,
  fieldsMap.tr_cpa,
  fieldsMap.ts_cpc,
  fieldsMap.tr_cpc,
  fieldsMap.ts_cpi,
  fieldsMap.hour_of_day,
  fieldsMap.today_ts_clicks,
];

const toFields = [
  fieldsMap.ts_impressions,
  fieldsMap.ts_clicks,
  fieldsMap.tr_clicks,
  fieldsMap.ts_spent,
  fieldsMap.ts_conversions,
  fieldsMap.tr_conversions,
  fieldsMap.ts_revenue,
  fieldsMap.tr_revenue,
  fieldsMap.totalBudget,
  fieldsMap.dailyBudget,
  fieldsMap.bid,
  fieldsMap.payout,
  fieldsMap.lp_clicks,
  fieldsMap.lp_ctr,
  fieldsMap.ts_epc,
  fieldsMap.epi,
  fieldsMap.tr_epc,
  fieldsMap.ts_ctr,
  fieldsMap.tr_ctr,
  fieldsMap.ts_cr,
  fieldsMap.tr_cr,
  fieldsMap.ts_profit,
  fieldsMap.tr_profit,
  fieldsMap.ts_roi,
  fieldsMap.tr_roi,
  fieldsMap.ts_cpa,
  fieldsMap.tr_cpa,
  fieldsMap.ts_cpc,
  fieldsMap.tr_cpc,
  fieldsMap.ts_cpi,
  fieldsMap.today_ts_clicks,
];

const conditions = [
  { value: { key: 'greater', behind: 'THAN' }, text: 'Greater' },
  { value: { key: 'less', behind: 'THAN' }, text: 'Less' },
  { value: { key: 'greater_equal', behind: 'THAN / TO' }, text: 'Greater or Equal' },
  { value: { key: 'less_equal', behind: 'THAN / TO' }, text: 'Less or Equal' },
];

const conditionsMap = {
  greater: { value: { key: 'greater', behind: 'THAN' }, text: '>' },
  less: { value: { key: 'less', behind: 'THAN' }, text: '<' },
  greater_equal: { value: { key: 'greater_equal', behind: 'THAN / TO' }, text: '=>' },
  less_equal: { value: { key: 'less_equal', behind: 'THAN / TO' }, text: '<=' },
};

const conditionsDailyCap = [
  { value: { key: 'greater_equal', behind: ' ' }, text: 'Reached' },
  { value: { key: 'less', behind: ' ' }, text: 'Not Reached' },
];
const conditionsDailyCapMap = {
  greater_equal: { value: { key: 'greater_equal', behind: 'IS' }, text: 'reached' },
  less: { value: { key: 'less', behind: 'IS' }, text: 'not reached' },
};

const conditionsTranslator = (conditions, hourOffDay, returnMapped) => {
  const conditionsArray = conditions.map((condition) => Object.entries(condition)[0]).map(([key, value]) => {
    let cKey = key;
    if (value.tracker_account_id && value.tracker_account_id !== 1) cKey = `${cKey}::${value.tracker_account_id}`;
    let itemData = [];
    if (!fieldsMap[cKey]) {
      itemData = [
        value.value,
        conditionsMap[value.condition],
        { value: { key: cKey, behind: 'IS', step: 1 }, text: cKey, class: 'badge-yellow-gold' },
      ];
    } else if (key === 'today_ts_clicks') {
      itemData = [
        '',
        conditionsDailyCapMap[value.condition],
        { value: { key: 'Daily Cap', behind: 'IS', step: 1 }, text: 'Daily Cap', class: 'badge-yellow-gold' },
      ];
    } else {
      itemData = [
        fieldsMap[cKey].value.type === 'time' ? ui.timeFormat(value.value) : value.value,
        conditionsMap[value.condition],
        fieldsMap[cKey],
      ];
    }
    // To Field
    let toKey = value.to;
    if (value.tracker_account_id_2 && value.tracker_account_id_2 !== 1) toKey = `${toKey}::${value.tracker_account_id}`;
    if (toKey && fieldsMap[toKey]) {
      itemData.push(fieldsMap[toKey]);
    } else {
      itemData.push(null);
    }
    return itemData;
  }).map(([value, condition, field, toField]) => {
    let html = `<span class="badge badge-pill ${field.class}">${field.text} ${condition.text} `;
    if (toField) {
      html += `${value} % of campaign ${toField.text}`;
    } else {
      if (field.value.placeholderPosition === 'before') html += `${field.value.placeholder}`;
      html += `${value}`;
      if (field.value.placeholderPosition === 'after') html += `${field.value.placeholder}`;
    }
    html += '</span>';
    return { key: field.value.key, html, placeholder: field.value.placeholder };
  });
  if (returnMapped) {
    return conditionsArray;
    // eslint-disable-next-line no-else-return
  } else {
    const conditionsArrayHtml = conditionsArray.map(({ html }) => html);
    if (hourOffDay) conditionsArrayHtml.push('<span class="badge badge-pill badge-blue badge-clock"><i class="fa fa-clock-o"></i></span>');
    return conditionsArrayHtml.join(' <b>&</b> ');
  }
};

/* **************** CC Fields ***************** */
let ccFields = [];
const loadCcFields = async () => {
  if (ccFields.length === 0) {
    const response = await apiStore.rules.ccFields();
    ccFields = response.map((ccItem) => {
      const item = { group: 'cc', value: { key: ccItem.key, behind: 'IS', step: ccItem.step }, text: ccItem.text, class: 'badge-yellow-gold' };
      if (ccItem.tracker_account_id !== 1) item.value.key = `${item.value.key}::${ccItem.tracker_account_id}`;
      return item;
    });
    // Add fields
    fields.splice(fields.length - 1, 0, ...ccFields);
    if (toFields.length) toFields.push(...ccFields);
    ccFields.forEach((item) => {
      fieldsMap[item.value.key] = item;
    });
  }
};
/* ******************************************** */

let promises;

export default {
  async getData() {
    if (typeof promises === 'undefined') promises = loadCcFields();
    if (promises !== null) {
      await promises;
      promises = null;
    }
    return { fieldsGroup, fields, fieldsMap, conditions, conditionsTranslator, conditionsDailyCap, toFields };
  },
};
